import API from "./axios";

// Focus companies offered in the push picker (Vesara intentionally excluded).
export const FOCUS_COMPANIES = [
  { id: 36, label: "Naman (NTC)" },
  { id: 72, label: "Etna" },
];

export interface FocusPushResult {
  voucherNo: string;
  company: number;
  customer: string;
  value: number;
  date: string;
  dryRun: boolean;
  payload?: unknown; // present only on dry-run
}

// One selectable line item in the Push-to-Focus picker. `idx` is the stable 0-based line
// index the backend assigns; it is what we send back in `lines` to choose what to push.
export interface FocusPushItem {
  idx: number;
  code: string;            // Focus item code (product master vcProductCode)
  desc: string;            // item description
  qty: number | string;    // ordered quantity
}

interface ApiEnvelope<T> {
  status: number;   // 100 = success, 101 = error
  msg: string;
  data: T | "";
}

// Fetch the order/quotation line items so the operator can pick which ones to post.
export function fetchFocusPushItems(type: "order" | "quote", id: number) {
  return API.post("api/index.php", {
    action: "getFocusPushItems",
    [type === "order" ? "orderId" : "quoteId"]: id,
  }) as unknown as Promise<ApiEnvelope<FocusPushItem[]>>;
}

// `lines` (optional) = the 0-based indices of the items to include. Omit to push every line.
function push(
  action: "pushOrderToFocus" | "pushQuotationToFocus",
  id: number,
  company: number,
  dryRun = false,
  lines?: number[],
) {
  return API.post("api/index.php", {
    action,
    [action === "pushOrderToFocus" ? "orderId" : "quoteId"]: id,
    company,
    dryrun: dryRun ? 1 : 0,
    ...(lines ? { lines } : {}),
  }) as unknown as Promise<ApiEnvelope<FocusPushResult>>;
}

export const pushOrderToFocus = (orderId: number, company: number, dryRun = false, lines?: number[]) =>
  push("pushOrderToFocus", orderId, company, dryRun, lines);

export const pushQuotationToFocus = (quoteId: number, company: number, dryRun = false, lines?: number[]) =>
  push("pushQuotationToFocus", quoteId, company, dryRun, lines);
